import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, Flex, NakedButton, Text } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import { useDataLayer } from 'hooks/useDataLayer';
import { clearFilters } from 'store/propertyAvailability/propertyAvailabilityActions';
import { getActiveFilters } from 'store/propertyAvailability/propertyAvailabilitySelectors';

const BaseText = styled(Text)`
  color: ${themeGet('colors.greys.charcoal')};
  font-size: ${themeGet('fontSizes.base')};
`;

const Button = styled(NakedButton)`
  color: ${themeGet('colors.brand.primary')};

  &:hover {
    outline: none;
    color: ${themeGet('colors.brand.primary')};
  }

  &:disabled {
    cursor: not-allowed;
    box-shadow: none;
    color: ${themeGet('colors.greys.steel')};
  }
`;

const FilterHeader = () => {
  const dispatch = useDispatch();
  const { emitInteractionEvent } = useDataLayer();
  const activeFilters = useSelector(getActiveFilters);
  const count = activeFilters.length;
  const isDisabled = count === 0;
  const onClear = useCallback(() => {
    dispatch(clearFilters());
    emitInteractionEvent({ type: 'Room Type Filters', value: 'Clear Filters Selected' });
  }, [dispatch, emitInteractionEvent]);

  return <UnconnectedFilterHeader count={count} onClear={onClear} isDisabled={isDisabled} />;
};

export const UnconnectedFilterHeader = ({ count, onClear, isDisabled }) => (
  <Flex alignItems="center" textAlign="left" mb={4}>
    <Icon name="tune" color="greys.charcoal" size={[18, 22]} mr={2} data-testid="filters-list-icon" />
    <BaseText data-testid="filters-header">Filters</BaseText>
    {!!count && (
      <BaseText ml={1} data-testid="filter-count">
        ({count})
      </BaseText>
    )}
    <BaseText mx={4}>|</BaseText>
    <Button data-testid="clear-filters" onClick={onClear} disabled={isDisabled}>
      Clear Filters
    </Button>
  </Flex>
);

UnconnectedFilterHeader.propTypes = {
  count: PropTypes.number.isRequired,
  onClear: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};

export default FilterHeader;
